export default "__VITE_ASSET__DHr2i8Fy__"